import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import Intro_3 from "../../../assets/images/intro_3.svg";

const ThirdStep = () => {
  return (
    <div className="px-10 bg-white h-screen flex flex-col items-center justify-center">
      <Fade triggerOnce>
        <div className="flex flex-col items-center justify-between">
          <img
            src={Intro_3}
            alt="بادی‌بان"
            className="w-full max-w-xs lg:w-6/12 mb-10"
          />
          <div className="flex flex-col items-center justify-center">
            <h2 className="text-xl text-right max-w-3xl font-rokh font-[700] lg:w-9/12 leading-relaxed">
              پس جای خوبی اومدی! <br /> بادی‌بان اینجاست تا تو رو به بهترین دوست
              بدنت تبدیل کنه. کافیه عکس آزمایشت رو آپلود کنی تا تفسیر رایگانش رو
              بهت بگیم.{" "}
            </h2>
            <Link
              to="/login"
              className="text-pr_primary font-bold text-xl btn btn-outline btn-wide w-full lg:w-4/12 mt-16"
            >
              شـــروع
            </Link>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default ThirdStep;
